/** @file signOut: logs out on the server and sends the editor back to the login gate. */
import type { EditorStore } from '../state/editorTypes';
import type { EditorApi } from '../store/editorApi';

/** `api.logout()`, then the session becomes anonymous whether or not the server answered. */
export function signOut(store: EditorStore, api: EditorApi | null): void {
  const done = (): void => { store.setState((s) => ({ session: { ...s.session, owner: null, status: 'anonymous' } })); };
  if (api === null) done();
  else void api.logout().finally(done);
}
